import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InsulinPageContent, Spinner } from "@madmedical/ui";
import { useState } from "react";
import { useMe, usePatientId } from "@madmedical/user";
import { UnderlyingCondition } from "@madmedical/medical";
import AddCommentButtonForm from "../../comment/components/AddCommentButtonForm";
import { useGetInsulinProcolByPatientQuery } from "../api";
import CreateInsulinReminderModalForm from "./CreateInsulinReminderModalForm";
import CreateInsulinAdministrationModalForm from "./ManualInsulinAdministrationModalForm";
import UpdateInsulinProtocolModalForm from "./UpdateInsulinProtocolModalForm";
import InsulinBodyChartProvider from "./InsulinBodyChartProvider";
import InsulinPortioningProvider from "./InsulinPortioningProvider";
import InsulinBloodSugarProvider from "./InsulinBloodSugarProvider";
var ModalState;
(function (ModalState) {
    ModalState[ModalState["Closed"] = 0] = "Closed";
    ModalState[ModalState["AdministrationOpen"] = 1] = "AdministrationOpen";
    ModalState[ModalState["ReminderOpen"] = 2] = "ReminderOpen";
    ModalState[ModalState["ProtocolOpen"] = 3] = "ProtocolOpen";
})(ModalState || (ModalState = {}));
export const InsulinPage = () => {
    var _a;
    const { roles: { isPatient }, patient, } = useMe();
    const { patientId } = usePatientId();
    const { data: insulinProtocol, isLoading, refetch: refetchProtocol, } = useGetInsulinProcolByPatientQuery({
        patientId,
    });
    const [insulinAdministrationModal, setInsulinAdministrationModal] = useState(ModalState.Closed);
    const [insulinReminderModal, setInsulinReminderModal] = useState(ModalState.Closed);
    const [insulinProtocolModal, setInsulinProtocolModal] = useState(ModalState.Closed);
    const [selectedProtocol, setSelectedProtocol] = useState({
        id: "",
        instructions: "",
    });
    const editSelectedProtocol = (id, instructions) => {
        setInsulinProtocolModal(ModalState.ProtocolOpen);
        setSelectedProtocol({
            id,
            instructions,
        });
    };
    if (isLoading) {
        return _jsx(Spinner, {});
    }
    const insulinUser = (patient === null || patient === void 0 ? void 0 : patient.underlyingConditions.includes(UnderlyingCondition.Insulin)) &&
        ((_a = patient === null || patient === void 0 ? void 0 : patient.packages) === null || _a === void 0 ? void 0 : _a.some((p) => p.type === "diabetes"));
    return (_jsxs(InsulinBloodSugarProvider, { children: [_jsx(InsulinPageContent, { addCommentButton: _jsx(AddCommentButtonForm, {}), onAddInsulinAdministration: () => setInsulinAdministrationModal(ModalState.AdministrationOpen), onAddInsulinReminder: () => setInsulinReminderModal(ModalState.ReminderOpen), isPatient: isPatient, insulinProtocol: insulinProtocol, editInsulinProtocol: editSelectedProtocol, BodyChartWrapper: InsulinBodyChartProvider, PortioningWrapper: InsulinPortioningProvider, insulinUser: insulinUser }), _jsx(CreateInsulinAdministrationModalForm, { open: insulinAdministrationModal === ModalState.AdministrationOpen, onClose: () => setInsulinAdministrationModal(ModalState.Closed) }), _jsx(CreateInsulinReminderModalForm, { open: insulinReminderModal === ModalState.ReminderOpen, onClose: () => setInsulinReminderModal(ModalState.Closed) }), _jsx(UpdateInsulinProtocolModalForm, { open: insulinProtocolModal === ModalState.ProtocolOpen, onClose: () => setInsulinProtocolModal(ModalState.Closed), protocol: selectedProtocol, refetchProtocol: refetchProtocol })] }));
};
